import { Button, Text, Tooltip } from '@shared/components';
import { LuArrowLeft, LuCircleCheck } from 'react-icons/lu';
import { PiCheck, PiPlus } from 'react-icons/pi';
import type {
  ExistingCarrierNode,
  OutboundPlanCarrier,
} from './ExistingCarriers';

type CarrierContactsListProps = {
  carrier: ExistingCarrierNode;
  onBack?: () => void;
  onAddToPlan?: (carrier: OutboundPlanCarrier) => void;
  isAddedToPlan?: boolean;
};

export const CarrierContactsList = ({
  carrier,
  onBack,
  onAddToPlan,
  isAddedToPlan,
}: CarrierContactsListProps) => {
  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {onBack && (
            <Button
              variant="tertiary"
              size="small"
              onPress={onBack}
              icon={<LuArrowLeft className="h-4 w-4" />}
            />
          )}
          <Text type="body-md" className="font-semibold">
            Contacts for {carrier.name}
          </Text>
        </div>
        {onAddToPlan && (
          <Button
            variant={isAddedToPlan ? 'tertiary' : 'secondary'}
            size="small"
            isDisabled={isAddedToPlan}
            labelClassName={isAddedToPlan ? '!px-2' : undefined}
            icon={
              isAddedToPlan ? (
                <PiCheck className="h-3.5 w-3.5" />
              ) : (
                <PiPlus className="h-3.5 w-3.5" />
              )
            }
            onPress={() =>
              onAddToPlan({
                carrierId: carrier.id,
                carrierName: carrier.name,
                mcNumber: carrier.mcNumber,
                contacts: carrier.contacts?.map((c) => ({
                  id: c.id,
                  name: c.name,
                  email: c.email,
                  phone: c.phone,
                })),
              })
            }
          >
            {isAddedToPlan ? 'Added' : 'Add to Plan'}
          </Button>
        )}
      </div>
      <div className="space-y-4">
        {carrier.contacts?.length > 0 ? (
          carrier.contacts.map((contact) => (
            <div key={contact.id} className="rounded-lg border p-3">
              <div className="flex items-center gap-2">
                <Text>{contact.name}</Text>
                {contact.isVerified && (
                  <Tooltip content="Verified contact">
                    <span className="text-green-600" aria-label="verified">
                      <LuCircleCheck className="h-4 w-4" />
                    </span>
                  </Tooltip>
                )}
              </div>
              {(contact.email || contact.phone) && (
                <div className="mt-2 flex flex-col">
                  {contact.email && (
                    <Text className="text-sm text-gray-600">
                      {contact.email}
                    </Text>
                  )}
                  {contact.phone && (
                    <Text className="text-sm text-gray-600">
                      {contact.phone}
                    </Text>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <Text className="text-gray-500">No contacts available</Text>
        )}
      </div>
    </div>
  );
};
